import { Container } from "reactstrap";
import { useScreenSize } from "../../utils/hooks/useScreenSize ";
import { BackButton } from "../Hajj/BackButton";
import { Breadcrumb, Space } from "antd";
import { Link, useLocation, useParams } from "react-router-dom";
import { buildBreadcrumbs } from "../../utils/breadcrumbs";
import { useTranslation } from "react-i18next";

export const PageHeader = (props) => {
  const {
    children,
    title,
    backTo = null,
    sticky = true,
    hideBreadcrumb = false,
  } = props;
  const { t } = useTranslation();

  const { width } = useScreenSize();
  const location = useLocation();
  const params = useParams();
  const urlPathTitleMap = location.pathname?.split("/")?.pop();
  const urlTitle = urlPathTitleMap?.replaceAll("-", "_").toUpperCase();

  const dynamicParams = Array.isArray(Object.values(params)) ? Object.values(params).slice(1) : [];

  const crumbs = buildBreadcrumbs(
    location?.pathname || "/",
    title && urlPathTitleMap ? { [urlPathTitleMap]: title } : undefined,
    dynamicParams,
    t
  );

  const safeCrumbs = Array.isArray(crumbs) ? crumbs : [];
  const crumbsHasHref = safeCrumbs.filter((c) => c && c.href);
  const defaultBackTo = crumbsHasHref.slice(0).pop()?.href;

  return (
    <>
      <Container
        fluid
        className={`${sticky ? "sticky-top bg-white z-1" : ""}`}
        style={sticky ? { top: width <= 575 ? "70px" : "78px" } : undefined}
      >
        <div className="d-flex justify-content-between align-items-center py-4 border-bottom flex-wrap">
          <h2 className="H2">
            <Space>
              {(backTo || (defaultBackTo && crumbsHasHref.length > 1)) && (
                <BackButton to={backTo || defaultBackTo} />
              )}
              <span>{title ?? t(urlTitle)}</span>
            </Space>
          </h2>
          {children}
        </div>
      </Container>
      <Container fluid>
        {!hideBreadcrumb && (
          <div className="py-2">
            <Breadcrumb
              items={safeCrumbs.map((c) => ({
                title: c?.href ? <Link to={c.href}>{c.label}</Link> : (c?.label ?? ""),
              }))}
            />
          </div>
        )}
      </Container>
    </>
  );
};
